const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOncologypatientBro(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-118"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M384,130.47a222.64,222.64,0,0,0-10.85-19.79C327,37.35,203.49-2.57,142.3,73.22c-14.59,18.07-19.67,39.9-29.49,60.62-22.32,47.12-64,75.29-90.19,118.92C2.34,286.58,5,329.93,16.35,366.49,28.64,406.22,50.27,434,84.87,455.07c38.79,23.64,80.27,17.08,122.2,8.85,18.86-3.7,38.3-7.48,57.57-6.07,24.14,1.77,48,8.9,71.92,12.36,24.9,3.6,50.74,4.45,74.74-3.4,76.82-25.13,95-142.9,63.43-210.37-11.18-23.88-30.14-42.3-47.74-61C408,175.27,396.35,155.52,384,130.47Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384,130.47a222.64,222.64,0,0,0-10.85-19.79C327,37.35,203.49-2.57,142.3,73.22c-14.59,18.07-19.67,39.9-29.49,60.62-22.32,47.12-64,75.29-90.19,118.92C2.34,286.58,5,329.93,16.35,366.49,28.64,406.22,50.27,434,84.87,455.07c38.79,23.64,80.27,17.08,122.2,8.85,18.86-3.7,38.3-7.48,57.57-6.07,24.14,1.77,48,8.9,71.92,12.36,24.9,3.6,50.74,4.45,74.74-3.4,76.82-25.13,95-142.9,63.43-210.37-11.18-23.88-30.14-42.3-47.74-61C408,175.27,396.35,155.52,384,130.47Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-118"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M485.23,438.82H47.32a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H485.23a.5.5,0,0,1,.5.5A.51.51,0,0,1,485.23,438.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.93,438.82H16.53a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5h25.4a.5.5,0,0,1,.5.5A.51.51,0,0,1,41.93,438.82Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-118"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M473.42,309.43s-4.61,6.27-8.85,11.76-8.08,9-12.31,10.2c-3.41.95-11.79,1.64-14.94,1.88l-5.84,33.07h-3.85l8.46-33c0-.68.21-9.18,5-14.07,5-5.1,21.16-3.92,23.47-5.1S473.42,309.43,473.42,309.43Zm-43.06,3.69c-2.91,8-9.07,48.24-9.66,53.61l-4.23-.78V317.66s-1.16-7.84-5-10.59-5.77-2.74-5.77-2.74a39.24,39.24,0,0,0-13.08,3.53,30,30,0,0,0-9.38,6.94c5.86.37,14.74.88,18.23,4.43,4.8,4.89,5,13.39,5,14.07l8.47,33h-3.85l-5.84-33.07c-3.15-.24-11.54-.93-14.94-1.88-4-1.12-7.73-4.39-11.74-9.46-1.86,3.86-3.27,7.89-3.27,7.89a44.43,44.43,0,0,1,1.7-9.92c-3.93-5.14-7.86-10.47-7.86-10.47s6.54,3.53,8.85,4.7a3.94,3.94,0,0,0,1,.28,31.42,31.42,0,0,1,4.79-7.73c8.09-9.42,16.94-10.59,22.71-8.63s8.85,5.49,9.24,6.67,2.31,9,2.31,9-1.93-14.12-3.08-22,.38-17.26,2.69-25.5,9.24-23.92,9.24-23.92,6.54,18.43,8.08,33.34a59,59,0,0,1-1.3,21c3.84-6.42,10.23-12,17.08-15.55,12.7-6.67,20.78-3.92,20.78-3.92s-7.7,1.18-11.93,5.1-11.93,15.3-15,22.75-13.85,9.41-13.85,9.41C430.57,314.06,430.46,313.59,430.36,313.12Zm-.26-1.54a20.52,20.52,0,0,1,.4-7.25c-.19.28-.38.54-.56.78-3.08,3.92-10,13.34-10,15.69,0,1.25.22,7.66.42,13.42l.73-.08s3.47-12.16,5.78-16.87A54.21,54.21,0,0,1,430.1,311.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "443.02 402.14 418.77 400.99 394.53 402.14 384.52 438.31 388.76 438.31 400.69 419.46 418.77 419.46 436.86 419.46 448.79 438.31 453.03 438.31 443.02 402.14",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453,438.82h-4.24a.49.49,0,0,1-.42-.24L436.59,420H401l-11.78,18.62a.49.49,0,0,1-.42.24h-4.24a.51.51,0,0,1-.48-.64l10-36.17a.5.5,0,0,1,.46-.37l24.24-1.15L443,401.64a.49.49,0,0,1,.46.37l10,36.17a.51.51,0,0,1-.48.64Zm-4-1h3.3l-9.74-35.2-23.88-1.14-23.83,1.14-9.74,35.2h3.3l11.78-18.63a.54.54,0,0,1,.43-.23h36.17a.52.52,0,0,1,.43.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.53,365.19h48.11a0,0,0,0,1,0,0v43.18a5.7,5.7,0,0,1-5.7,5.7H400.23a5.7,5.7,0,0,1-5.7-5.7V365.19A0,0,0,0,1,394.53,365.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.94,414.57H400.23a6.21,6.21,0,0,1-6.2-6.2V365.19a.5.5,0,0,1,.5-.5h48.11a.51.51,0,0,1,.5.5v43.18A6.21,6.21,0,0,1,436.94,414.57ZM395,365.69v42.68a5.2,5.2,0,0,0,5.2,5.2h36.71a5.21,5.21,0,0,0,5.2-5.2V365.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.66,
    y: 402.14,
    width: 3.85,
    height: 36.18,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.51,438.82h-3.85a.5.5,0,0,1-.5-.5V402.14a.5.5,0,0,1,.5-.5h3.85a.5.5,0,0,1,.5.5v36.18A.51.51,0,0,1,420.51,438.82Zm-3.35-1H420V402.64h-2.85Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Picture--inject-118"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.17,180H313.42a.5.5,0,0,1-.5-.5V48.24a.5.5,0,0,1,.5-.5H420.17a.5.5,0,0,1,.5.5V179.45A.5.5,0,0,1,420.17,180Zm-106.25-1H419.67V48.74H313.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.21,173.87H318.37a.5.5,0,0,1-.5-.5v-119a.5.5,0,0,1,.5-.5h96.84a.5.5,0,0,1,.5.5v119A.5.5,0,0,1,415.21,173.87Zm-96.34-1h95.84v-118H318.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.68,173.59a.5.5,0,0,1-.3-.9c10.37-7.75,19.34-20.43,26.67-37.67,18.07-42.53,31.62-60.34,50-65.71a.49.49,0,0,1,.62.34.5.5,0,0,1-.33.62c-17.83,5.2-31.67,23.47-49.37,65.14-7.4,17.41-16.48,30.22-27,38.08A.47.47,0,0,1,338.68,173.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.84,104a4.4,4.4,0,0,1-1.62-.3c-4.19-1.7-5.22-10.11-6.3-19-1.27-10.41-2.58-21.18-8.77-21.73-4.59-.41-9,2.26-13.32,7.93a.5.5,0,1,1-.8-.6c4.49-6,9.29-8.77,14.21-8.33,7,.63,8.35,11.8,9.67,22.6,1,8.23,2,16.74,5.69,18.21,1.69.68,4-.17,6.92-2.53,10.18-8.28,16.26-24,17.6-45.57a.51.51,0,0,1,.53-.47.5.5,0,0,1,.47.53c-1.36,21.82-7.57,37.83-18,46.29C352.69,103,350.61,104,348.84,104Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.19,155.79a.45.45,0,0,1-.27-.08c-43.23-28.77-76.45-27.15-96.71-20.72a.5.5,0,1,1-.3-1c20.47-6.49,54-8.15,97.56,20.85a.5.5,0,0,1,.14.69A.48.48,0,0,1,415.19,155.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.35,120.84h-.11c-15.66-3.36-26-10-30.74-19.86C378,89.52,380,73.87,389.64,54.46a.5.5,0,0,1,.9.44C381.08,74,379,89.38,384.4,100.54c4.6,9.52,14.71,16,30.05,19.31a.51.51,0,0,1,.39.59A.5.5,0,0,1,414.35,120.84Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-118"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 163.79,
    y: 131.26,
    width: 2.81,
    height: 6.18,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.6,137.94h-2.81a.5.5,0,0,1-.5-.5v-6.18a.5.5,0,0,1,.5-.5h2.81a.5.5,0,0,1,.5.5v6.18A.5.5,0,0,1,166.6,137.94Zm-2.31-1h1.81v-5.18h-1.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.1 125.13 164.92 132.05 148.2 125.13 149.74 80.96 180.56 80.96 182.1 125.13",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.92,132.55a.43.43,0,0,1-.19,0L148,125.59a.5.5,0,0,1-.31-.48L149.24,81a.51.51,0,0,1,.5-.49h30.82a.51.51,0,0,1,.5.49l1.54,44.16a.51.51,0,0,1-.31.49l-17.18,6.91A.43.43,0,0,1,164.92,132.55Zm-16.21-7.75,16.21,6.71,16.67-6.71-1.51-43.34H150.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.18 123.24 164.95 129.15 150.12 123.24 151.49 85.5 178.81 85.5 180.18 123.24",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165,129.65a.58.58,0,0,1-.19,0l-14.82-5.91a.5.5,0,0,1-.32-.49L151,85.48a.5.5,0,0,1,.5-.48h27.32a.5.5,0,0,1,.5.48l1.37,37.74a.5.5,0,0,1-.32.49l-15.23,5.91Zm-14.32-6.74L165,128.62l14.72-5.72L178.33,86H152Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.1,125.13,182,121.6c-3.9,1.9-13.43,6.4-17.19,6.75s-12.89-4.63-16.47-6.71l-.12,3.49,16.72,6.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.92,132.55a.43.43,0,0,1-.19,0L148,125.59a.5.5,0,0,1-.31-.48l.12-3.48a.49.49,0,0,1,.26-.42.48.48,0,0,1,.49,0c2.85,1.65,12.42,7,16.17,6.64s13.13-4.8,17-6.7a.5.5,0,0,1,.72.44l.12,3.52a.51.51,0,0,1-.31.49l-17.18,6.91A.43.43,0,0,1,164.92,132.55Zm-16.21-7.75,16.21,6.71,16.67-6.71-.09-2.41c-4.27,2.07-13,6.12-16.67,6.46s-12-4-16-6.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.56 80.96 149.74 80.96 149.66 83.26 180.64 83.26 180.56 80.96",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.64,83.76h-31a.48.48,0,0,1-.36-.15.54.54,0,0,1-.14-.36l.08-2.3a.51.51,0,0,1,.5-.49h30.82a.51.51,0,0,1,.5.49l.08,2.3a.54.54,0,0,1-.14.36A.48.48,0,0,1,180.64,83.76Zm-30.46-1h29.94l0-1.3H150.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,84.53h-.05c-4.64-.25-6.59-2.92-6.67-3a1,1,0,1,1,1.62-1.17c.07.09,1.55,2,5.15,2.2a1,1,0,0,1,0,2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.64,206.91h0a1,1,0,0,1-1-1c0-2.83,0-5,0-5a1,1,0,0,1,2,0s0,2.18,0,5A1,1,0,0,1,142.64,206.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.4,232a12.15,12.15,0,0,1-7.41-2.34c-3.31-2.65-2.84-6.24-2.35-10,.15-1.21.31-2.46.36-3.7.08-2.75.12-6.94.14-10a.5.5,0,1,1,1,0c0,3-.06,7.23-.15,10,0,1.29-.2,2.56-.36,3.8-.48,3.66-.89,6.83,2,9.13a11.88,11.88,0,0,0,9.35,1.85,7.11,7.11,0,0,0,5-3.5c1.91-3.83,4.57-60.27,5.71-89.58a.51.51,0,0,1,.52-.48.5.5,0,0,1,.48.52c-.14,3.46-3.33,85-5.82,90a8,8,0,0,1-5.71,4A13,13,0,0,1,151.4,232Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.12,
    y: 69.84,
    width: 5.96,
    height: 368.47,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.07,438.82h-5.95a.5.5,0,0,1-.5-.5V69.84a.5.5,0,0,1,.5-.5h5.95a.5.5,0,0,1,.5.5V438.32A.5.5,0,0,1,125.07,438.82Zm-5.45-1h4.95V70.34h-4.95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.26,
    y: 434.81,
    width: 60.02,
    height: 3.65,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.28,439h-60a.5.5,0,0,1-.5-.5v-3.65a.5.5,0,0,1,.5-.5h60a.5.5,0,0,1,.5.5v3.65A.5.5,0,0,1,152.28,439Zm-59.52-1h59v-2.65h-59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.24,84.53a7.41,7.41,0,0,1-4.62-1.6l-.16-.13A7.43,7.43,0,0,1,73,74.74,9.61,9.61,0,0,1,82.2,68h79.2a9.62,9.62,0,0,1,9.19,6.7,7.47,7.47,0,0,1-2.44,8.06l-.16.13a7.41,7.41,0,0,1-11.8-7.59l.71-2.82a1,1,0,0,1,1.21-.72,1,1,0,0,1,.73,1.21l-.71,2.81a5.4,5.4,0,0,0,8.61,5.54l.16-.13a5.41,5.41,0,0,0,1.78-5.88A7.63,7.63,0,0,0,161.4,70H82.2a7.64,7.64,0,0,0-7.28,5.31,5.43,5.43,0,0,0,1.78,5.88l.16.13a5.4,5.4,0,0,0,8.61-5.54L84.77,73a1,1,0,0,1,.72-1.21,1,1,0,0,1,1.22.72l.7,2.82a7.38,7.38,0,0,1-7.17,9.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.1,
    y: 153.76,
    width: 52.24,
    height: 46.49,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.34,200.75H97.1a.5.5,0,0,1-.5-.5V153.76a.5.5,0,0,1,.5-.5h52.24a.5.5,0,0,1,.5.5v46.49A.5.5,0,0,1,149.34,200.75Zm-51.74-1h51.24V154.26H97.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.85,
    y: 162.16,
    width: 28.25,
    height: 29.68,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.11,192.34H115.85a.5.5,0,0,1-.5-.5V162.16a.51.51,0,0,1,.5-.5h28.26a.51.51,0,0,1,.5.5v29.68A.5.5,0,0,1,144.11,192.34Zm-27.76-1h27.26V162.66H116.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.09,
    y: 153.76,
    width: 28.25,
    height: 46.49,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.34,200.75H121.09a.5.5,0,0,1-.5-.5V153.76a.5.5,0,0,1,.5-.5h28.25a.5.5,0,0,1,.5.5v46.49A.5.5,0,0,1,149.34,200.75Zm-27.75-1h27.25V154.26H121.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.39,
    y: 156.98,
    width: 23.65,
    height: 40.05,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147,197.53H123.39a.5.5,0,0,1-.5-.5V157a.5.5,0,0,1,.5-.5H147a.5.5,0,0,1,.5.5V197A.5.5,0,0,1,147,197.53Zm-23.15-1h22.65V157.48H123.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.09,
    y: 177.35,
    width: 4.05,
    height: 4.05,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.14,181.9h-4a.51.51,0,0,1-.5-.5v-4.05a.5.5,0,0,1,.5-.5h4a.5.5,0,0,1,.5.5v4.05A.5.5,0,0,1,129.14,181.9Zm-3.55-1h3v-3.05h-3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.54,
    y: 177.35,
    width: 4.05,
    height: 4.05,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.6,181.9h-4.06a.51.51,0,0,1-.5-.5v-4.05a.5.5,0,0,1,.5-.5h4.06a.5.5,0,0,1,.5.5v4.05A.51.51,0,0,1,134.6,181.9Zm-3.56-1h3.06v-3.05H131Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 177.35,
    width: 4.05,
    height: 4.05,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.05,181.9H136a.5.5,0,0,1-.5-.5v-4.05a.5.5,0,0,1,.5-.5h4.05a.5.5,0,0,1,.5.5v4.05A.51.51,0,0,1,140.05,181.9Zm-3.55-1h3.05v-3.05H136.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.45,
    y: 177.35,
    width: 4.05,
    height: 4.05,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.5,181.9h-4.05a.5.5,0,0,1-.5-.5v-4.05a.5.5,0,0,1,.5-.5h4.05a.5.5,0,0,1,.5.5v4.05A.51.51,0,0,1,145.5,181.9Zm-3.55-1H145v-3.05H142Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.09,
    y: 183.39,
    width: 4.05,
    height: 4.05,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.14,187.94h-4a.5.5,0,0,1-.5-.5v-4.05a.51.51,0,0,1,.5-.5h4a.5.5,0,0,1,.5.5v4.05A.5.5,0,0,1,129.14,187.94Zm-3.55-1h3v-3.05h-3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.54,
    y: 183.39,
    width: 4.05,
    height: 4.05,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.6,187.94h-4.06a.5.5,0,0,1-.5-.5v-4.05a.51.51,0,0,1,.5-.5h4.06a.51.51,0,0,1,.5.5v4.05A.5.5,0,0,1,134.6,187.94Zm-3.56-1h3.06v-3.05H131Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 183.39,
    width: 4.05,
    height: 4.05,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.05,187.94H136a.5.5,0,0,1-.5-.5v-4.05a.5.5,0,0,1,.5-.5h4.05a.51.51,0,0,1,.5.5v4.05A.5.5,0,0,1,140.05,187.94Zm-3.55-1h3.05v-3.05H136.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.45,
    y: 183.39,
    width: 4.05,
    height: 4.05,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.5,187.94h-4.05a.5.5,0,0,1-.5-.5v-4.05a.5.5,0,0,1,.5-.5h4.05a.51.51,0,0,1,.5.5v4.05A.5.5,0,0,1,145.5,187.94Zm-3.55-1H145v-3.05H142Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.47,317.53c-7.4,0-8.44-5.51-8.45-5.57V180.15c0-4.62,2.22-6.55,2.31-6.63a.5.5,0,1,1,.65.76s-2,1.77-2,5.87V311.87c0,.13,1,5.2,8.68,4.61,8-.64,10.91-4.34,12.64-6.55s22.83-32,23-32.26a.49.49,0,0,1,.69-.12.5.5,0,0,1,.12.7c-.86,1.22-21.26,30-23.06,32.29s-4.93,6.26-13.36,6.94C122.32,317.51,121.89,317.53,121.47,317.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.09,
    y: 189.44,
    width: 4.05,
    height: 4.05,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.14,194h-4a.5.5,0,0,1-.5-.5v-4.05a.5.5,0,0,1,.5-.5h4a.5.5,0,0,1,.5.5v4.05A.5.5,0,0,1,129.14,194Zm-3.55-1h3v-3.05h-3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.54,
    y: 189.44,
    width: 4.05,
    height: 4.05,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.6,194h-4.06a.5.5,0,0,1-.5-.5v-4.05a.5.5,0,0,1,.5-.5h4.06a.5.5,0,0,1,.5.5v4.05A.5.5,0,0,1,134.6,194ZM131,193h3.06v-3.05H131Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 189.44,
    width: 4.05,
    height: 4.05,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.05,194H136a.5.5,0,0,1-.5-.5v-4.05a.5.5,0,0,1,.5-.5h4.05a.5.5,0,0,1,.5.5v4.05A.5.5,0,0,1,140.05,194Zm-3.55-1h3.05v-3.05H136.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.45,
    y: 189.44,
    width: 4.05,
    height: 4.05,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.5,194h-4.05a.5.5,0,0,1-.5-.5v-4.05a.5.5,0,0,1,.5-.5h4.05a.5.5,0,0,1,.5.5v4.05A.5.5,0,0,1,145.5,194ZM142,193H145v-3.05H142Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.3 302.81 151.94 288.53 173.74 288.53 152.19 302.81 87.3 302.81",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.19,303.31H87.3a.5.5,0,0,1-.11-1L151.83,288h21.91a.48.48,0,0,1,.47.35.49.49,0,0,1-.2.57l-21.54,14.28A.57.57,0,0,1,152.19,303.31Zm-60.31-1H152l20-13.28H152Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.3,
    y: 302.81,
    width: 64.89,
    height: 3.76,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.19,307.07H87.3a.51.51,0,0,1-.5-.5v-3.76a.5.5,0,0,1,.5-.5h64.89a.5.5,0,0,1,.5.5v3.76A.5.5,0,0,1,152.19,307.07Zm-64.39-1h63.89v-2.76H87.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.77,299.74c-1.23-1.55-50.11-20.42-50.11-20.42L298.61,169.15a12.79,12.79,0,0,0-12.71-11.39H208.6a12.79,12.79,0,0,0-12.71,11.39l-12,110.17S135,298.19,133.73,299.74s-1.55,5.26,0,6.49c.88.71,8.75.61,15.33.39a8.82,8.82,0,0,1,9.11,8.81V438.32H336.34V315.43a8.81,8.81,0,0,1,9.1-8.81c6.58.22,14.45.32,15.33-.39C362.32,305,362,301.28,360.77,299.74Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.34,438.82H158.17a.5.5,0,0,1-.5-.5V315.43a8.22,8.22,0,0,0-2.54-6,8.32,8.32,0,0,0-6.06-2.34c-14.44.48-15.32-.23-15.65-.5a4.27,4.27,0,0,1-1.23-3.53,6.45,6.45,0,0,1,1.15-3.67c1.24-1.55,41.24-17.06,50-20.45l12-109.87a13.26,13.26,0,0,1,13.2-11.84h77.3a13.27,13.27,0,0,1,13.21,11.84l12,109.87c8.8,3.39,48.79,18.9,50,20.45h0c1.31,1.64,1.76,5.74-.07,7.2-.34.27-1.22,1-15.66.5a8.32,8.32,0,0,0-8.59,8.31V438.32A.51.51,0,0,1,336.34,438.82Zm-177.67-1H335.84V315.43a9.23,9.23,0,0,1,2.83-6.69,9.35,9.35,0,0,1,6.79-2.62c12.91.43,14.75-.11,15-.28,1.26-1,1-4.39-.07-5.78-1.39-1.27-30.59-12.81-49.91-20.27a.51.51,0,0,1-.31-.41L298.11,169.21a12.26,12.26,0,0,0-12.21-11H208.6a12.26,12.26,0,0,0-12.21,11l-12,110.17a.52.52,0,0,1-.32.41c-19.35,7.47-48.6,19-49.92,20.28a5.6,5.6,0,0,0-.92,3.05,3.44,3.44,0,0,0,.86,2.72c.25.17,2.09.71,15,.28a9.33,9.33,0,0,1,9.63,9.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,285.44a.49.49,0,0,1-.41-.22c-4.45-6.43-9.25-5.59-9.45-5.56a.49.49,0,0,1-.59-.39.51.51,0,0,1,.39-.59c.23,0,5.62-1,10.47,6a.49.49,0,0,1-.12.69A.52.52,0,0,1,200,285.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.72,285.44a.51.51,0,0,1-.28-.09.5.5,0,0,1-.13-.69c4.85-7,10.25-6,10.48-6a.51.51,0,0,1,.39.59.5.5,0,0,1-.59.39c-.21,0-5-.87-9.45,5.56A.5.5,0,0,1,295.72,285.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.29,326.36H318a0,0,0,0,1,0,0v37.34a4.87,4.87,0,0,1-4.87,4.87h-135a4.87,4.87,0,0,1-4.87-4.87V326.36A0,0,0,0,1,173.29,326.36Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.14,369.07h-135a5.37,5.37,0,0,1-5.37-5.36V326.36a.51.51,0,0,1,.5-.5H318a.5.5,0,0,1,.5.5v37.35A5.37,5.37,0,0,1,313.14,369.07ZM173.79,326.86v36.85a4.37,4.37,0,0,0,4.37,4.36h135a4.37,4.37,0,0,0,4.37-4.36V326.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.29,438.55a.51.51,0,0,1-.5-.5V425.6a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5v12.45A.5.5,0,0,1,173.29,438.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.29,419.91a.5.5,0,0,1-.5-.5V369.88a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5v49.53A.5.5,0,0,1,173.29,419.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.27,438.55a.5.5,0,0,1-.5-.5V381.36a.5.5,0,0,1,1,0v56.69A.5.5,0,0,1,318.27,438.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.27,377.44a.5.5,0,0,1-.5-.5v-7.06a.5.5,0,0,1,1,0v7.06A.5.5,0,0,1,318.27,377.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192,243.83l-5.49,15.95s-6.74,4.45-14,9-12.82,6.88-16.05,7.83-12.42.81-14,1.35-12.68,9.31-11.87,10.38,15,7.7,16.87,7.7,10.39-8.5,10.39-8.5,25.5-3.92,31.43-6.48,8.77-3.64,9.18-4.18,13.35-26.72,13.35-26.72Z",
    style: {
      fill: "#d1d1d1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.37,296.58c-1.91,0-16.27-6.57-17.27-7.9a.81.81,0,0,1-.09-.74c.67-2.14,10.65-9.9,12.21-10.42a31.7,31.7,0,0,1,5.4-.49,51.45,51.45,0,0,0,8.65-.86c2-.59,7.59-2.52,15.93-7.77,6.62-4.17,12.86-8.28,13.88-8.94l5.43-15.8a.5.5,0,0,1,.62-.31l19.75,6.38a.48.48,0,0,1,.31.28.49.49,0,0,1,0,.41c-2.16,4.38-13,26.25-13.4,26.8s-1.52,1-5.47,2.67l-3.91,1.67c-5.74,2.48-29,6.12-31.4,6.48C156.31,289.72,149.31,296.58,147.37,296.58ZM131,288.16c1.36,1.12,14.59,7.42,16.39,7.42,1,0,5.93-4.25,10-8.36a.57.57,0,0,1,.28-.14c.25,0,25.5-3.93,31.31-6.44l3.92-1.68a31.75,31.75,0,0,0,5.06-2.35c.43-.67,9.33-18.59,13.05-26.11l-18.73-6.05L187,259.94a.52.52,0,0,1-.2.26c-.07,0-6.83,4.51-14,9-8.14,5.13-13.64,7.14-16.18,7.89a49.74,49.74,0,0,1-8.88.9,36.05,36.05,0,0,0-5.14.44C140.86,279,131.57,286.6,131,288.16Zm55.51-28.38h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.71,275.93a.55.55,0,0,1-.34-.13.5.5,0,0,1,0-.71c.31-.35,7.77-8.61,14.37-11.91,5.63-2.81,9.59-2.16,11.77,1.95a3,3,0,0,1,.23,2.52c-.66,1.83-3,2.82-3.08,2.86l-3.36,1.41a.51.51,0,0,1-.66-.26.52.52,0,0,1,.27-.66l3.36-1.41s2-.87,2.53-2.28a2,2,0,0,0-.18-1.71c-1.21-2.29-3.61-4.93-10.43-1.52-6.43,3.21-14,11.6-14.08,11.68A.51.51,0,0,1,159.71,275.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.84,273.82a1,1,0,0,1-.39-1.92l3.24-1.36a1,1,0,0,1,1.31.54,1,1,0,0,1-.54,1.3l-3.23,1.37A1.07,1.07,0,0,1,175.84,273.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.33,274.59l3.43,5.08L177,275.61a43.43,43.43,0,0,0-2.92-4.32l-.76-.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.76,280.17a.52.52,0,0,1-.42-.22l-3.42-5.08a.48.48,0,0,1-.07-.42.51.51,0,0,1,.29-.32l10-4.06a.49.49,0,0,1,.54.11l.77.76a40.24,40.24,0,0,1,3,4.41.52.52,0,0,1,.05.42.51.51,0,0,1-.29.3l-10.29,4.07A.57.57,0,0,1,166.76,280.17Zm-2.67-5.34,2.86,4.23,9.35-3.7a34.38,34.38,0,0,0-2.53-3.71l-.53-.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.85,288s-1.89,2.16-1.62,2.56,1.08,2.16,2.3,2,6.11-3.86,6.11-5.18a2.39,2.39,0,0,0-2.55-2.17A10.05,10.05,0,0,0,131.85,288Z",
    style: {
      fill: "#d1d1d1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.39,293.08c-1.26,0-2-1.37-2.45-2l-.12-.22c-.16-.23-.48-.72,1.63-3.14a10.29,10.29,0,0,1,4.55-2.95,2.71,2.71,0,0,1,2.13.67,2.63,2.63,0,0,1,1,2c0,1.73-5.23,5.53-6.56,5.67Zm-1.67-2.69.09.14c.28.49.92,1.62,1.66,1.54,1.07-.12,5.67-3.71,5.67-4.68a1.65,1.65,0,0,0-.65-1.22,1.78,1.78,0,0,0-1.31-.46,9.74,9.74,0,0,0-3.9,2.54l-.05.06A10.79,10.79,0,0,0,130.72,290.39Zm1.13-2.41h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.2,292.49a13,13,0,0,0,2.55,2.26c.85.38,4.34-2.83,5.1-4.06a1.44,1.44,0,0,0-.85-2.26,6.3,6.3,0,0,0-2.36,0Z",
    style: {
      fill: "#d1d1d1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.87,295.27a.79.79,0,0,1-.32-.06,13,13,0,0,1-2.72-2.39.49.49,0,0,1,0-.7l4.43-4.06a.49.49,0,0,1,.25-.12,6.28,6.28,0,0,1,2.62,0,2.22,2.22,0,0,1,1.38,1.29,2,2,0,0,1-.28,1.71C141.68,291.93,138.41,295.27,136.87,295.27Zm-2-2.75a10.48,10.48,0,0,0,2,1.78c.59,0,3.69-2.6,4.47-3.87a1,1,0,0,0,.19-.86,1.29,1.29,0,0,0-.79-.67,5.1,5.1,0,0,0-1.95,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.07,294.85s2.83,1.22,3.78,1.13,3.77-3.49,3.49-4.72-2.83-1.32-2.83-1.32Z",
    style: {
      fill: "#d1d1d1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.75,296.48a14.58,14.58,0,0,1-3.88-1.17.56.56,0,0,1-.29-.36.51.51,0,0,1,.12-.44l4.44-4.91a.51.51,0,0,1,.39-.16c.3,0,2.94.15,3.3,1.71.19.81-.49,2-1.09,2.82s-2,2.42-2.84,2.51Zm-2.83-1.82a10.3,10.3,0,0,0,2.88.82,6.91,6.91,0,0,0,2.29-2.33c.69-1,.81-1.6.76-1.78-.12-.53-1.27-.84-2.13-.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143,296.07s2,1.23,2.93.76,2.64-3.21,2.26-4.25-2.83-1.32-2.83-1.32Z",
    style: {
      fill: "#d1d1d1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.38,297.44a6.06,6.06,0,0,1-2.66-.94.51.51,0,0,1-.19-.65l2.36-4.81a.52.52,0,0,1,.51-.28c.46.06,2.78.39,3.24,1.65s-1.37,4.3-2.51,4.87A1.68,1.68,0,0,1,145.38,297.44Zm-1.74-1.57c.71.37,1.65.71,2,.51.8-.4,2.29-2.89,2-3.63-.16-.44-1.23-.79-2.07-.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.17,277.46S144.67,276,142.1,276s-5.53-.13-5.8.81-2.83,5.53-4.72,7.15-2.83,4.86-1.08,4.45,5.13-1.61,5.13-1.61l5.67-4.59s3.77,2.29,4.72,2.29",
    style: {
      fill: "#d1d1d1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.22,288.92a1.05,1.05,0,0,1-1-.59c-.54-1.07.46-3.44,2-4.78,1.77-1.51,4.31-6,4.56-6.91.33-1.14,2.28-1.2,5.43-1.17h.85c2.58,0,10.81,1.43,11.15,1.49a.5.5,0,0,1,.41.58.51.51,0,0,1-.58.41c-.08,0-8.48-1.48-11-1.48h-.86c-1.39,0-4.29,0-4.46.45-.29,1-2.9,5.7-4.87,7.39-1.37,1.18-2,3.09-1.79,3.57,0,.06.16,0,.27,0,1.56-.36,4.47-1.39,5-1.58l5.6-4.53a.5.5,0,0,1,.57,0A19.74,19.74,0,0,0,146,284a.51.51,0,0,1,.5.5.5.5,0,0,1-.5.5c-.92,0-3.53-1.49-4.68-2.18l-5.4,4.36a.42.42,0,0,1-.14.09c-.14.05-3.42,1.23-5.19,1.63A1.39,1.39,0,0,1,130.22,288.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.23,294.09s-1-4.8-1.25-6,.33-1.59-1.1-3.18a28,28,0,0,0-8.21-5,40,40,0,0,0-7-1c-1.07,0-6.41-2.7-6.41-2.7l-12.57-9c-3.64-7.83-10.09-23.27-10.09-23.27l-19.55,4.43q2.63,7.05,5.36,14.08c3.6,9.26,7.3,22.08,19.4,22.7l11.75.61,3.23,4.74a61.17,61.17,0,0,0,6.14,3.46c1.47.52,4.06,2.95,4.06,2.95a2.07,2.07,0,0,0,2.4-1.52c.39-1.83.25-2.21-.65-2.93s-4.45-3.45-4.45-3.45l3.1-1.36s3.06,3.12,3.45,3.61,1.45,6.24,2.37,7.6,2.82-.4,2.82-.4,1.62,1.52,2.42.8,1.11-2.74,1.09-3.37-.35-3.26-.35-3.26,1.34,4.81,2.36,5.28,2.65.29,2.68-.78A7.94,7.94,0,0,0,350.23,294.09Z",
    style: {
      fill: "#d1d1d1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345,299.84a3.46,3.46,0,0,1-1.9-.84,3.17,3.17,0,0,1-2.08.75,1.59,1.59,0,0,1-1.15-.72,22.31,22.31,0,0,1-1.69-5.21,20.71,20.71,0,0,0-.68-2.38c-.27-.34-2.18-2.31-3.15-3.3l-2,.88c1.08.82,3.13,2.41,3.79,2.94,1.1.88,1.24,1.46.83,3.42a2.51,2.51,0,0,1-3,1.92.5.5,0,0,1-.26-.13,17,17,0,0,0-3.89-2.85,58.09,58.09,0,0,1-6.24-3.51.4.4,0,0,1-.15-.14l-3.09-4.54-11.49-.59c-11.37-.58-15.54-11.63-18.89-20.51-.32-.86-.64-1.7-1-2.51-1.83-4.72-3.64-9.46-5.36-14.09a.5.5,0,0,1,.36-.66l19.55-4.43a.49.49,0,0,1,.57.29c.06.16,6.42,15.37,10,23.14l12.46,9a37.57,37.57,0,0,0,6.14,2.61,39.89,39.89,0,0,1,7.08,1.07,28.24,28.24,0,0,1,8.44,5.17,3.39,3.39,0,0,1,1.17,2.65,4.15,4.15,0,0,0,.05.76c.21,1.09,1.11,5.29,1.24,5.91a7.78,7.78,0,0,1,1.06,3.13,1.39,1.39,0,0,1-.69,1.17,3,3,0,0,1-2.7,0,3.94,3.94,0,0,1-1.33-1.88,5.56,5.56,0,0,1-1.23,3.15A1.22,1.22,0,0,1,345,299.84Zm-1.9-2a.51.51,0,0,1,.35.13c.53.5,1.46,1,1.73.8a5.33,5.33,0,0,0,.93-3c0-.48-.24-2.31-.35-3.21a.5.5,0,0,1,1-.2c.69,2.48,1.65,4.75,2.09,4.95a2.09,2.09,0,0,0,1.75,0,.38.38,0,0,0,.22-.35,7.3,7.3,0,0,0-1-2.68.34.34,0,0,1-.05-.14c-.05-.19-1-4.82-1.26-6a4.87,4.87,0,0,1-.07-.95c0-.59,0-1-.92-2a27.46,27.46,0,0,0-8-4.89,39.06,39.06,0,0,0-6.82-1c-1.12,0-5.72-2.3-6.62-2.76l-12.64-9.09a.49.49,0,0,1-.16-.19c-3.29-7.06-8.91-20.46-9.94-22.9l-18.58,4.21c1.66,4.46,3.39,9,5.16,13.54l1,2.52c3.41,9.05,7.29,19.32,18,19.86l11.74.61a.51.51,0,0,1,.39.22l3.17,4.65a57.45,57.45,0,0,0,6,3.36,17.18,17.18,0,0,1,4.11,2.94,1.49,1.49,0,0,0,1.7-1.14c.36-1.76.2-1.89-.49-2.44-.9-.73-4.44-3.45-4.44-3.45a.49.49,0,0,1-.19-.45.5.5,0,0,1,.3-.4l3.1-1.35a.51.51,0,0,1,.56.1c.31.32,3.08,3.15,3.48,3.64a10.45,10.45,0,0,1,.85,2.74,23.73,23.73,0,0,0,1.55,4.9.61.61,0,0,0,.44.29c.56.07,1.38-.56,1.62-.78A.5.5,0,0,1,343.07,297.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.57,298.37s-.25-6.55-.26-6.91a17.84,17.84,0,0,0-1.39-4,36,36,0,0,0-3.22-4.3.51.51,0,0,1,.05-.71.49.49,0,0,1,.7.05,34.9,34.9,0,0,1,3.36,4.5,16.82,16.82,0,0,1,1.5,4.46c0,.35.26,6.9.26,6.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.23,293a.49.49,0,0,1-.5-.47c-.11-2.1-.28-4.46-.39-4.79s-2.23-2.87-4.12-5.1A.5.5,0,1,1,342,282a64.85,64.85,0,0,1,4.29,5.41,42.61,42.61,0,0,1,.44,5.08.49.49,0,0,1-.47.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.81,295.34h-.05a1.14,1.14,0,0,1-1-.72,13.26,13.26,0,0,0-1-1.68.46.46,0,0,1-.07-.16l-1.31-5.85a.5.5,0,0,1,.25-.55.52.52,0,0,1,.6.1,20,20,0,0,1,2.42,2.9c0,.06.07.17.14.33,1.17,2.9,1.51,4.2,1.24,4.8A1.37,1.37,0,0,1,351.81,295.34Zm-1.15-2.87a13.29,13.29,0,0,1,1,1.8.12.12,0,0,0,.13.07.37.37,0,0,0,.33-.25c0-.16,0-.89-1.26-4l-.15-.37a10.66,10.66,0,0,0-.94-1.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.49,272.12a.5.5,0,0,1-.28-.91c.26-.17,6.26-4.09,11.86-3.94a.5.5,0,0,1,.48.51.51.51,0,0,1-.51.49h-.32c-5.22,0-10.89,3.74-11,3.78A.48.48,0,0,1,299.49,272.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.77,433l-5.49,6.55-12.69,8.82c-1.84,1.29-1.1,4.42-.73,5.89s13.79,5.14,22.79,5.14,15.08-4.41,17.65-6.06,6.25-2,8.64-4,1.23-10,1.23-10-5.82-11.32-12.44-16.84-9.75-3.12-14,.19S183.77,433,183.77,433Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.65,459.9c-8.18,0-22.76-3.46-23.28-5.52-.36-1.47-1.22-4.9.94-6.42l12.63-8.78,5.35-6.38c.14-1.1,1.11-7.39,5.16-10.56,4.27-3.34,7.64-6,14.6-.17,6.62,5.51,12.33,16.52,12.57,17a.88.88,0,0,1,0,.15c.12.85,1.12,8.33-1.4,10.46a15.31,15.31,0,0,1-4.94,2.44,18.48,18.48,0,0,0-3.76,1.65l-.57.37A30.68,30.68,0,0,1,187.65,459.9Zm8.1-40.25c-2.37,0-4.3,1.51-6.69,3.38-4,3.14-4.79,10-4.79,10a.47.47,0,0,1-.12.27l-5.49,6.54-.1.09-12.68,8.82c-1.6,1.12-.83,4.2-.54,5.36.68,1.13,13.18,4.76,22.31,4.76,8.24,0,14-3.78,16.8-5.6l.58-.38a18.63,18.63,0,0,1,4-1.75,14.74,14.74,0,0,0,4.62-2.26c1.76-1.49,1.38-7.26,1.07-9.47-.52-1-6.09-11.45-12.28-16.6C199.65,420.54,197.57,419.65,195.75,419.65Zm-12,13.35h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.3,453.34c2.58-1.66,6.25-2,8.64-4,1-.83,1.37-2.68,1.47-4.56a28.69,28.69,0,0,0-9.37,4c-5.33,3.68-9,6.62-20,6.62a56.3,56.3,0,0,1-21-4.6l-.63,0a11.53,11.53,0,0,0,.45,3.46c.36,1.47,13.79,5.14,22.79,5.14S202.73,455,205.3,453.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.65,459.9c-8.18,0-22.76-3.46-23.28-5.52a12.43,12.43,0,0,1-.46-3.61.51.51,0,0,1,.47-.47l.63,0a.52.52,0,0,1,.24.05A56.17,56.17,0,0,0,186,454.86c10.34,0,14.15-2.65,19-6l.77-.53a29.24,29.24,0,0,1,9.55-4.09.49.49,0,0,1,.43.11.47.47,0,0,1,.18.41c-.14,2.46-.69,4.11-1.64,4.91a15.31,15.31,0,0,1-4.94,2.44,18.48,18.48,0,0,0-3.76,1.65l-.57.37A30.68,30.68,0,0,1,187.65,459.9Zm-22.75-8.63a12.31,12.31,0,0,0,.44,2.87c.68,1.13,13.18,4.76,22.31,4.76,8.24,0,14-3.78,16.8-5.6l.58-.38h0a18.63,18.63,0,0,1,4-1.75,14.74,14.74,0,0,0,4.62-2.26c.64-.54,1.07-1.76,1.24-3.53a27.65,27.65,0,0,0-8.54,3.77l-.77.53c-5,3.45-8.9,6.18-19.55,6.18A57.2,57.2,0,0,1,165,451.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.16,433l5.49,6.55,12.69,8.82c1.83,1.29,1.1,4.42.73,5.89s-13.79,5.14-22.8,5.14-15.07-4.41-17.64-6.06-6.26-2-8.65-4-1.23-10-1.23-10,5.83-11.32,12.45-16.84,9.74-3.12,14,.19S313.16,433,313.16,433Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.27,459.9a30.64,30.64,0,0,1-17.34-5.77l-.58-.37a18.38,18.38,0,0,0-3.75-1.65,15.21,15.21,0,0,1-4.94-2.44c-2.53-2.13-1.52-9.61-1.4-10.46a.44.44,0,0,1,.05-.15c.24-.47,5.95-11.48,12.57-17,7-5.81,10.33-3.17,14.6.17,4,3.17,5,9.46,5.16,10.56l5.35,6.38L331.62,448c2.16,1.52,1.3,5,.94,6.42C332,456.44,317.46,459.9,309.27,459.9Zm-27-20.46c-.31,2.21-.69,8,1.07,9.47a14.74,14.74,0,0,0,4.62,2.26,18.63,18.63,0,0,1,4,1.75l.58.38c2.77,1.82,8.55,5.6,16.79,5.6,9.14,0,21.64-3.63,22.33-4.8.28-1.12,1-4.2-.55-5.32L318.37,440l-.1-.09-5.5-6.54a.54.54,0,0,1-.11-.27c0-.07-.79-6.89-4.8-10-4.21-3.3-7-5.48-13.34-.19C288.33,428,282.75,438.46,282.24,439.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.63,453.34c-2.58-1.66-6.26-2-8.65-4-1-.83-1.36-2.68-1.47-4.56a28.73,28.73,0,0,1,9.38,4c5.33,3.68,9,6.62,20,6.62a56.3,56.3,0,0,0,21-4.6l.62,0a11.56,11.56,0,0,1-.44,3.46c-.37,1.47-13.79,5.14-22.8,5.14S294.2,455,291.63,453.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.27,459.9a30.64,30.64,0,0,1-17.34-5.77l-.58-.37a18.38,18.38,0,0,0-3.75-1.65,15.21,15.21,0,0,1-4.94-2.44c-1-.8-1.5-2.46-1.65-4.91a.52.52,0,0,1,.18-.41.54.54,0,0,1,.44-.11,29.11,29.11,0,0,1,9.54,4.09l.77.53c4.84,3.35,8.65,6,19,6a56.24,56.24,0,0,0,20.75-4.55.47.47,0,0,1,.24-.05l.63,0a.5.5,0,0,1,.46.47,12.14,12.14,0,0,1-.45,3.61C332,456.44,317.46,459.9,309.27,459.9Zm-27.2-14.52c.17,1.77.59,3,1.24,3.53a14.74,14.74,0,0,0,4.62,2.26,18.63,18.63,0,0,1,4,1.75h0l.58.38c2.77,1.82,8.55,5.6,16.79,5.6,9.14,0,21.64-3.63,22.33-4.8a12.73,12.73,0,0,0,.43-2.83h0a57.2,57.2,0,0,1-21.05,4.59c-10.65,0-14.58-2.73-19.56-6.18l-.76-.53A27.65,27.65,0,0,0,282.07,445.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.42,361.15S324.71,324,324,320.2s-3-12.06-12.57-18.84-14.9-7.39-14.9-7.39c-10.13-6.39-48.15-4.17-48.15-4.17s-38-2.22-48.16,4.17c0,0-5.36.61-14.9,7.39s-11.81,15.07-12.56,18.84,7.53,40.95,7.53,40.95l6,48.49v8.29L182,424.71l1.76,8.29s5-7.28,9.3-9,7.78,0,10.55,3,11.55,12.31,11.55,12.31,1-3.77,1.51-6.79-.5-6.78-1-9.8a100.43,100.43,0,0,1-1.26-10.3c0-1.75.75-49.49.75-55s2-16.07,2.52-19.34-1.26-8-1.26-8,28.64-3.52,29.64-3.27a5.93,5.93,0,0,0,2.27,0,5.87,5.87,0,0,0,2.26,0c1-.25,29.64,3.27,29.64,3.27s-1.76,4.77-1.25,8,2.51,13.82,2.51,19.34.75,53.27.75,55A102.93,102.93,0,0,1,281,422.7c-.51,3-1.51,6.79-1,9.8s1.51,6.79,1.51,6.79,8.79-9.3,11.55-12.31,6.29-4.78,10.56-3,9.29,9,9.29,9l1.76-8.29-4.27-6.78v-8.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.5,439.79l-.12,0a.47.47,0,0,1-.36-.36s-1-3.82-1.52-6.83c-.41-2.47.15-5.41.64-8,.13-.68.26-1.33.36-2a102.37,102.37,0,0,0,1.25-10.22c0-.63-.1-7.28-.22-15.69-.23-15.11-.53-35.79-.53-39.33,0-4.43-1.31-12.11-2.08-16.7-.18-1.06-.33-1.94-.43-2.56-.41-2.7.62-6.29,1.08-7.7-11.27-1.38-27.85-3.32-28.88-3.2a6.08,6.08,0,0,1-2.35,0,6.28,6.28,0,0,1-2.39,0c-1-.13-17.57,1.82-28.85,3.2.46,1.41,1.49,5,1.08,7.7-.1.62-.25,1.5-.43,2.57-.77,4.58-2.08,12.26-2.08,16.69,0,3.54-.3,24.22-.53,39.33-.12,8.41-.22,15.06-.22,15.69a102.37,102.37,0,0,0,1.25,10.22c.1.63.23,1.28.36,2,.49,2.59,1.06,5.53.64,8-.5,3-1.5,6.8-1.51,6.83a.5.5,0,0,1-.36.36.49.49,0,0,1-.49-.14c-.09-.09-8.83-9.33-11.56-12.32-3.09-3.37-6.46-4.34-10-2.89-4.09,1.68-9,8.8-9.08,8.87a.5.5,0,0,1-.51.21.52.52,0,0,1-.39-.39l-1.76-8.29a.53.53,0,0,1,.07-.37l4.19-6.66v-8.15l-6-48.43c-.34-1.47-8.3-37.28-7.53-41.1A30.26,30.26,0,0,1,185,301c8.89-6.31,14.16-7.33,15-7.46,10.27-6.33,46.8-4.28,48.35-4.19,1.5-.09,38-2.15,48.31,4.19.86.13,6.12,1.15,15,7.46a30.31,30.31,0,0,1,12.77,19.16c.76,3.81-7.13,39.3-7.54,41.13l-6,48.46v8.09l4.19,6.66a.48.48,0,0,1,.07.37l-1.76,8.29a.5.5,0,0,1-.39.39.51.51,0,0,1-.51-.21c-.05-.07-5-7.19-9.07-8.87-3.54-1.45-6.91-.48-10,2.89-2.73,3-11.47,12.23-11.56,12.32A.5.5,0,0,1,281.5,439.79ZM250.74,326.23c2.7,0,23.12,2.48,29.56,3.27a.52.52,0,0,1,.37.24.5.5,0,0,1,0,.43c0,.05-1.71,4.7-1.23,7.79.09.62.24,1.5.42,2.55.79,4.62,2.1,12.35,2.1,16.87,0,3.54.3,24.21.53,39.31.12,8.42.22,15.08.22,15.71a101.72,101.72,0,0,1-1.26,10.39q-.17.94-.36,2c-.48,2.51-1,5.35-.65,7.65.35,2.09.95,4.58,1.28,5.86,2.05-2.17,8.62-9.13,10.93-11.64,3.4-3.72,7.14-4.78,11.11-3.14,3.47,1.43,7.32,6.25,8.85,8.3l1.48-7L310,418.2a.5.5,0,0,1-.08-.27v-8.29l6-48.55a.43.43,0,0,0,0,0c2.3-10.31,8.14-37.73,7.53-40.74a29.27,29.27,0,0,0-12.36-18.53c-9.29-6.61-14.61-7.3-14.67-7.31a.48.48,0,0,1-.2-.07c-9.88-6.23-47.49-4.11-47.87-4.09s-38-2.14-47.91,4.09a.58.58,0,0,1-.21.07c-.06,0-5.38.7-14.67,7.31a29.25,29.25,0,0,0-12.36,18.53c-.61,3,5.23,30.43,7.53,40.74l6,48.54v8.35a.5.5,0,0,1-.07.27l-4.17,6.61,1.48,7c1.53-2.05,5.38-6.87,8.86-8.3,4-1.64,7.7-.58,11.11,3.14,2.3,2.51,8.87,9.47,10.92,11.64.33-1.28.93-3.77,1.28-5.86.38-2.3-.16-5.14-.64-7.66-.14-.68-.26-1.34-.37-2-.52-3.17-1.26-8.65-1.26-10.39,0-.63.1-7.29.22-15.71.23-15.1.53-35.77.53-39.31,0-4.51,1.31-12.24,2.1-16.86.18-1.06.33-1.94.42-2.56.48-3.1-1.21-7.74-1.23-7.79a.5.5,0,0,1,0-.43.52.52,0,0,1,.37-.24c6.74-.82,28.82-3.49,29.83-3.25a5.43,5.43,0,0,0,2,0h.19a5.43,5.43,0,0,0,2,0Zm60.15,91.7h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.74,328.32a.49.49,0,0,1-.46-.3c0-.07-3.43-7.67-8.27-10.75a.5.5,0,1,1,.54-.84c5.1,3.24,8.5,10.87,8.64,11.19a.49.49,0,0,1-.25.66A.51.51,0,0,1,215.74,328.32Z",
    style: {
      fill: "#787878"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.31,414.49a.51.51,0,0,1-.47-.32c0-.07-3-7.62-5.26-13.72s-8.88-39.13-9.16-40.53a.5.5,0,0,1,1-.2c.07.34,6.87,34.32,9.12,40.38s5.22,13.63,5.25,13.7a.5.5,0,0,1-.28.65A.39.39,0,0,1,212.31,414.49Z",
    style: {
      fill: "#787878"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.31,415.86a.48.48,0,0,1-.26-.07.51.51,0,0,1-.17-.69c0-.05,3.18-5.24,4.06-8.34a.51.51,0,0,1,.62-.34.49.49,0,0,1,.34.62c-.92,3.23-4,8.36-4.16,8.58A.52.52,0,0,1,188.31,415.86Z",
    style: {
      fill: "#787878"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.16,423.4a.48.48,0,0,1-.26-.07.51.51,0,0,1-.17-.69c.16-.25,3.77-6.07,8.15-9.06s10.17-8.14,10.23-8.19a.5.5,0,0,1,.71,0,.5.5,0,0,1,0,.7c-.06.06-6,5.32-10.34,8.27s-7.82,8.7-7.85,8.76A.5.5,0,0,1,283.16,423.4Z",
    style: {
      fill: "#787878"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.82,348.89a.54.54,0,0,1-.25-.06.52.52,0,0,1-.19-.69c6.08-10.57,13.82-36,13.9-36.23a.5.5,0,0,1,.62-.34.5.5,0,0,1,.34.63c-.08.25-7.86,25.77-14,36.44A.5.5,0,0,1,286.82,348.89Z",
    style: {
      fill: "#787878"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.88,328.55a.52.52,0,0,1-.21,0,.51.51,0,0,1-.25-.66c.15-.34,3.76-8.38,9.25-13.65a.5.5,0,0,1,.69.73c-5.35,5.13-9,13.24-9,13.32A.49.49,0,0,1,280.88,328.55Z",
    style: {
      fill: "#787878"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.73,319.18a.48.48,0,0,1-.48-.4c-1.33-6.42-9.64-16.13-9.72-16.23a.51.51,0,0,1,.05-.71.52.52,0,0,1,.71.06c.34.4,8.55,10,9.93,16.68a.49.49,0,0,1-.38.59Z",
    style: {
      fill: "#787878"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.05,317.12a.27.27,0,0,1-.13,0,.49.49,0,0,1-.35-.61c1.84-6.67,8.08-13.41,8.34-13.69a.5.5,0,1,1,.73.68c-.06.07-6.34,6.85-8.11,13.27A.49.49,0,0,1,255.05,317.12Z",
    style: {
      fill: "#787878"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.7,282.05l-2-30.49,17.95-7.73S293,220.3,292.34,218.6a13.27,13.27,0,0,0-4.8-5.57c-2.16-1.39-24.91-12.53-24.91-12.53l-14.82-.7-14.82.7S210.24,211.64,208.07,213a13.34,13.34,0,0,0-4.8,5.57c-.61,1.7-11.29,25.23-11.29,25.23l18,7.73-2,30.49s-6,3.71-6.19,4.64-1.55,7.28-1.55,7.28,7.12-3.1,14.39-.47S239.33,307,239.33,307l1.39,1.08,7.09-11.81,7.08,11.81,1.39-1.08S273.77,296.13,281,293.5s14.4.47,14.4.47-1.4-6.35-1.55-7.28S287.7,282.05,287.7,282.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.72,308.55a.48.48,0,0,1-.3-.11l-1.4-1.08c-.13-.08-17.48-10.8-24.62-13.39s-14,.42-14,.45a.49.49,0,0,1-.52-.07.51.51,0,0,1-.17-.49c0-.07,1.39-6.34,1.54-7.25s3.41-3.12,6.21-4.85l2-29.88-17.63-7.59a.57.57,0,0,1-.27-.28.52.52,0,0,1,0-.39c.11-.24,10.68-23.52,11.28-25.19a13.78,13.78,0,0,1,5-5.82c2.17-1.39,24-12.11,25-12.56A.45.45,0,0,1,233,200l14.82-.7,14.87.7a.46.46,0,0,1,.2.05c.93.45,22.8,11.17,25,12.56a13.64,13.64,0,0,1,5,5.82c.61,1.67,11.18,24.95,11.28,25.19a.53.53,0,0,1,0,.39.57.57,0,0,1-.27.28l-17.63,7.59,2,29.88c2.8,1.73,6.05,3.92,6.2,4.85s1.53,7.18,1.54,7.25a.47.47,0,0,1-.17.49.47.47,0,0,1-.51.07c-.07,0-7-3-14-.45s-24.49,13.31-24.66,13.42l-1.35,1.05a.48.48,0,0,1-.4.1.54.54,0,0,1-.34-.23l-6.65-11.1-6.66,11.1a.49.49,0,0,1-.33.23Zm-32.46-16.62a19.1,19.1,0,0,1,6.48,1.1c7.24,2.62,24.14,13.07,24.85,13.51l1,.77L247.38,296a.51.51,0,0,1,.86,0L255,307.31l.95-.74c.76-.47,17.66-10.92,24.89-13.54a21.62,21.62,0,0,1,13.88.14c-.39-1.79-1.23-5.67-1.35-6.4-.23-.52-3.28-2.64-6-4.29a.52.52,0,0,1-.24-.4l-2-30.48a.51.51,0,0,1,.3-.5L303,243.57c-1.54-3.4-10.52-23.21-11.1-24.8a12.75,12.75,0,0,0-4.6-5.32c-2-1.32-23.18-11.68-24.77-12.46l-14.72-.69-14.67.69c-1.59.78-22.72,11.14-24.77,12.46a12.83,12.83,0,0,0-4.6,5.32c-.57,1.59-9.55,21.4-11.1,24.8l17.49,7.53a.52.52,0,0,1,.3.5l-2,30.48a.52.52,0,0,1-.24.4c-2.69,1.65-5.73,3.77-6,4.33s-1,4.57-1.35,6.36A23.46,23.46,0,0,1,208.26,291.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.32,194.15a9.19,9.19,0,0,0-3.4,1.86,53.85,53.85,0,0,0-3.1,4.8s.31,7.89,1.24,11.14a53.54,53.54,0,0,1,1.39,7.43l10.06-6.81,5.26-1.55s10.06,2.78,11.14,3.09,3.87,6.66,5,5.27,4-15.33,3.71-18-1.7-6.81-2.79-7.73-5-1.09-5-1.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.5,220.07h0c-.89,0-1.75-1.27-3.07-3.3a10.41,10.41,0,0,0-1.62-2.18l-11-3.05L243.73,213l-10,6.77a.5.5,0,0,1-.78-.36,53.89,53.89,0,0,0-1.37-7.35c-.94-3.27-1.25-10.93-1.26-11.26a.54.54,0,0,1,.07-.27,54.39,54.39,0,0,1,3.15-4.87,9.74,9.74,0,0,1,3.63-2l.12,0,23.52-1.55c.47,0,4.13.19,5.31,1.21s2.67,5.58,3,8.06c.32,2.72-2.61,16.75-3.82,18.31A.94.94,0,0,1,264.5,220.07Zm-15.73-9.55a.27.27,0,0,1,.13,0s10.07,2.78,11.15,3.09c.59.17,1.18,1.05,2.18,2.6.64,1,1.82,2.8,2.27,2.85.9-1.21,3.9-14.91,3.58-17.6s-1.71-6.64-2.61-7.41c-.69-.6-3.22-.91-4.65-1l-23.41,1.55a8.43,8.43,0,0,0-3.11,1.68,49.57,49.57,0,0,0-3,4.6c0,1.09.38,8,1.21,10.88a52.52,52.52,0,0,1,1.31,6.69l9.38-6.35a.35.35,0,0,1,.14-.06l5.26-1.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.24,187.34l.31,13s.31,3.1,4.48,8,5.74,7.57,7.44,7.57,11.18-8,13.46-11.6a12.8,12.8,0,0,0,2.16-6.8l-.62-13-27.08.31Z",
    style: {
      fill: "#d1d1d1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.47,216.46c-1.52,0-2.74-1.51-5.16-4.51-.76-.94-1.63-2-2.66-3.24-4.23-5-4.59-8.19-4.6-8.32l-.31-13v0l.15-2.48a.49.49,0,0,1,.5-.46l27.08-.31a.51.51,0,0,1,.5.47l.62,13a13.2,13.2,0,0,1-2.24,7.1C260.07,208.28,250.47,216.46,248.47,216.46Zm-11.42-16.13s.37,3,4.37,7.74c1,1.22,1.91,2.31,2.67,3.25,2.15,2.67,3.34,4.14,4.38,4.14,1.36,0,10.71-7.64,13-11.36a12.55,12.55,0,0,0,2.09-6.52L263,185.06l-26.14.3-.12,2,.31,13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.24,187.34l.31,13a6.11,6.11,0,0,0,.31,1.23l15.58-8.86-13.56-7.87-2.49,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.86,202.07a.57.57,0,0,1-.18,0,.5.5,0,0,1-.29-.31,6.43,6.43,0,0,1-.34-1.34l-.31-13v0l.15-2.48a.49.49,0,0,1,.5-.46l2.49,0a.51.51,0,0,1,.25.06l13.56,7.88a.5.5,0,0,1,0,.87L237.11,202A.54.54,0,0,1,236.86,202.07Zm.19-1.74a3.86,3.86,0,0,0,.11.5l14.28-8.12-12.69-7.37-1.89,0-.12,2,.31,13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.11,164.51a3.1,3.1,0,0,1,3.67,1.49c1.26,2.29-.92,4.59-1.73,5.73a13,13,0,0,1-2.29,2.3Z",
    style: {
      fill: "#d1d1d1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.76,174.53a.46.46,0,0,1-.23-.06.5.5,0,0,1-.27-.46l.35-9.52A.49.49,0,0,1,266,164a3.56,3.56,0,0,1,4.26,1.73c1.26,2.28-.4,4.47-1.39,5.78l-.36.48a13.14,13.14,0,0,1-2.39,2.4A.51.51,0,0,1,265.76,174.53Zm.83-9.62-.29,8a9.9,9.9,0,0,0,1.35-1.46c.1-.16.23-.33.37-.52.9-1.18,2.26-3,1.32-4.69A2.53,2.53,0,0,0,266.59,164.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.27,164.51A3.1,3.1,0,0,0,228.6,166c-1.26,2.29.92,4.59,1.72,5.73a13.23,13.23,0,0,0,2.3,2.3Z",
    style: {
      fill: "#d1d1d1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.62,174.53a.51.51,0,0,1-.31-.11,13.14,13.14,0,0,1-2.39-2.4l-.36-.48c-1-1.31-2.65-3.5-1.39-5.78a3.56,3.56,0,0,1,4.26-1.73.49.49,0,0,1,.34.46l.35,9.52a.5.5,0,0,1-.27.46A.46.46,0,0,1,232.62,174.53Zm-1.32-9.66a2.47,2.47,0,0,0-2.26,1.37c-.94,1.71.42,3.51,1.32,4.69.14.19.27.36.37.52a9.9,9.9,0,0,0,1.35,1.46l-.29-8A3.23,3.23,0,0,0,231.3,164.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.66,144.27a15.89,15.89,0,0,0-7.45,2.84,11.08,11.08,0,0,0-4,5,31.52,31.52,0,0,0-2,11.05c0,1.2.41,17.67,1.41,20.88s9.84,9.84,13.66,10.65,5.62-.2,7.83-1.21,9.44-6.22,10.24-8.63,1.89-24-.2-31.93c-1.15-4.37-9-9-13.25-9A53.36,53.36,0,0,0,245.66,144.27Z",
    style: {
      fill: "#d1d1d1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.85,195.44a13.12,13.12,0,0,1-2.67-.3c-3.9-.83-13-7.53-14-11-1-3.3-1.43-19.91-1.43-21a32.29,32.29,0,0,1,2-11.22,11.39,11.39,0,0,1,4.16-5.19,16.46,16.46,0,0,1,7.68-2.94h0a56,56,0,0,1,6.3-.43c4.56,0,12.57,5,13.74,9.41,2.11,8,1,29.82.19,32.21-.88,2.64-8.39,8-10.5,8.94l-.42.19A11.18,11.18,0,0,1,249.85,195.44Zm2.05-51.1a52,52,0,0,0-6.18.43h0a15.38,15.38,0,0,0-7.21,2.75,10.4,10.4,0,0,0-3.81,4.73,31.26,31.26,0,0,0-2,10.87c0,1.89.45,17.73,1.39,20.73s9.45,9.5,13.28,10.31a9.66,9.66,0,0,0,7.1-1l.42-.19c2.18-1,9.24-6.14,10-8.34.78-2.35,1.86-23.77-.21-31.65C263.62,149,256.05,144.34,251.9,144.34Zm-6.24-.07h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241,145.24s5.39,4.7,8.72,5.28,9.17-4.25,9.17-4.25-4.36-3.21-8.6-3.21S241,145.24,241,145.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.27,151.06a4.62,4.62,0,0,1-.65-.05c-3.42-.59-8.73-5.2-9-5.39a.5.5,0,0,1-.16-.46.48.48,0,0,1,.29-.38,28.41,28.41,0,0,1,9.49-2.22c4.36,0,8.71,3.18,8.9,3.31a.5.5,0,0,1,.2.39.52.52,0,0,1-.18.4C259,146.85,253.81,151.06,250.27,151.06ZM242,145.4c1.51,1.22,5.34,4.19,7.84,4.62s6.76-2.59,8.24-3.72c-1.28-.82-4.58-2.74-7.75-2.74A26,26,0,0,0,242,145.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.68,150.75s2.41,2.63,2.3,5-4.48,6.77-4.48,6.77S231.7,157.51,234.68,150.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.5,163.06a.4.4,0,0,1-.15,0,.49.49,0,0,1-.34-.39c0-.22-.79-5.27,2.22-12.1a.5.5,0,0,1,.37-.29.48.48,0,0,1,.45.16c.11.11,2.55,2.82,2.43,5.41s-4.16,6.63-4.62,7.09A.51.51,0,0,1,232.5,163.06Zm2.32-11.35a24,24,0,0,0-1.9,9.69c1.39-1.53,3.49-4.14,3.56-5.63A7.11,7.11,0,0,0,234.82,151.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.16,150.75s-2.41,2.63-2.29,5,4.46,6,4.46,6S265.77,154,264.16,150.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.33,162.25a.45.45,0,0,1-.31-.11c-.46-.38-4.53-3.77-4.65-6.32s2.32-5.3,2.42-5.41a.5.5,0,0,1,.82.11c1.63,3.26,2.2,10.88,2.22,11.2a.49.49,0,0,1-.26.48A.52.52,0,0,1,266.33,162.25ZM264,151.7a7.1,7.1,0,0,0-1.66,4.07c.06,1.42,2,3.5,3.35,4.78A41.17,41.17,0,0,0,264,151.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.1,170.82a5.93,5.93,0,0,1-3.52-1.11.5.5,0,0,1,.62-.78h0c.11.09,2.67,2,6.32-.15a.5.5,0,0,1,.68.17.49.49,0,0,1-.17.69A7.55,7.55,0,0,1,241.1,170.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.16,170.82a5.86,5.86,0,0,1-3.52-1.11.49.49,0,0,1-.08-.7.5.5,0,0,1,.7-.08c.12.09,2.67,2,6.31-.15a.5.5,0,1,1,.52.86A7.57,7.57,0,0,1,257.16,170.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.63,165.81a.49.49,0,0,1-.39-.19.5.5,0,0,1,.08-.7,8.26,8.26,0,0,1,9.89-.7.49.49,0,0,1,.12.69.5.5,0,0,1-.7.12,7.17,7.17,0,0,0-8.68.67A.56.56,0,0,1,236.63,165.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.11,165.81a.46.46,0,0,1-.38-.19.5.5,0,0,1,.07-.7,8.26,8.26,0,0,1,9.89-.7.49.49,0,0,1,.12.69.5.5,0,0,1-.7.12,7.17,7.17,0,0,0-8.68.67A.52.52,0,0,1,252.11,165.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.38,179.35a3.85,3.85,0,0,1-3.33-1.88.5.5,0,0,1,.21-.67.51.51,0,0,1,.68.2,2.78,2.78,0,0,0,2.62,1.34,3.56,3.56,0,0,0,2.94-1.61.5.5,0,1,1,.83.56,4.59,4.59,0,0,1-3.71,2.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.57,184.5h-5.73a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h5.73a.5.5,0,0,1,.5.5A.5.5,0,0,1,252.57,184.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.36,283.33a.5.5,0,0,1-.09-1c.26-.05,26.76-5.08,31.13-5.74a.5.5,0,1,1,.15,1c-4.35.66-30.83,5.69-31.1,5.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.52,282.44a.5.5,0,0,1-.14-1c.54-.16,13.31-4,16.62-4.43a.5.5,0,1,1,.14,1c-3.24.43-16.34,4.35-16.48,4.39A.32.32,0,0,1,225.52,282.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.93,252.06h-.06a.51.51,0,0,1-.44-.56l3.68-29a.5.5,0,0,1,.56-.43.5.5,0,0,1,.43.56l-3.68,29A.49.49,0,0,1,209.93,252.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.69,252.06a.5.5,0,0,1-.49-.38l-6.32-26.33a.5.5,0,0,1,.37-.61.51.51,0,0,1,.6.37l6.32,26.34a.49.49,0,0,1-.37.6Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOncologypatientBro);
export default __webpack_public_path__ + "static/media/Oncology patient-bro.1dd3ecaa5f058da7c09819d2a4f8febc.svg";
export { ForwardRef as ReactComponent };